import React, { useState, useEffect } from "react";
import api from "../utils/api";
import { getUserdata } from "../helper/generalHelper";
import { useLanguages } from "../hooks/useLanguages";

const LanguageScreen = () => {
  const { languages , langLoading } = useLanguages();

  // const [languages, setLanguages] = useState([]);
  const [selectedLangCode, setSelectedLangCode] = useState(getUserdata("lang")); // Assume "en", "fr", etc.
  const [searchTerm, setSearchTerm] = useState("");
  // const [loading, setLoading] = useState(true);

  // Fetch all languages
  // useEffect(() => {
  //   const fetchLanguages = async () => {
  //     try {
  //       const response = await api.get("restaurant/lang/all");
  //       setLanguages(response.data.data || []);
  //     } catch (error) {
  //       console.error("Error fetching languages:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchLanguages();
  // }, []);

  // Handle language change
  const handleLanguageChange = async (langId, langCode) => {
    try {
      await api.get(`restaurant/lang/change?lang=${langId}`);
      setSelectedLangCode(langCode);
    } catch (error) {
      console.error("Error changing language:", error);
      alert("Failed to change language. Try again.");
    }
  };

  const filteredLanguages = languages.filter((lang) =>
    lang.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (langLoading)
    return (
      <p className="text-center text-gray-600 mt-10">Loading languages...</p>
    );

  const selectedLanguageName = languages.find(
    (lang) => lang.code === selectedLangCode
  )?.name;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-10">
      <div className="w-full max-w-2xl bg-white rounded-xl shadow-md p-6">
        <h2 className="text-3xl font-semibold text-center text-gray-800 mb-6">
          Select Your Language
        </h2>

        {/* Search Box */}
        <div className="mb-6">
          <input
            type="text"
            placeholder="Search language..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />
        </div>

        {/* Language List */}
        <div className="space-y-3 max-h-[400px] overflow-y-auto">
          {filteredLanguages.map((lang) => {
            const isSelected = selectedLangCode === lang.code;
            return (
              <div
                key={lang.id}
                className={`flex items-center justify-between px-4 py-3 rounded-lg border transition cursor-pointer ${
                  isSelected
                    ? "bg-blue-100 border-blue-500"
                    : "bg-gray-100 hover:bg-gray-200 border-transparent"
                }`}
                onClick={() => handleLanguageChange(lang.id, lang.code)}
              >
                <span className="text-gray-800 font-medium">{lang.name}</span>
                <input
                  type="radio"
                  name="language"
                  checked={isSelected}
                  readOnly
                  className="form-radio text-blue-600 h-5 w-5"
                />
              </div>
            );
          })}

          {filteredLanguages.length === 0 && (
            <p className="text-gray-500 text-center">No languages found.</p>
          )}
        </div>

        {/* Current Selection Notice */}
        {selectedLanguageName && (
          <p className="mt-6 text-center text-sm text-green-600 font-medium">
            ✅ Language changed to <strong>{selectedLanguageName}</strong>
          </p>
        )}
      </div>
    </div>
  );
};

export default LanguageScreen;
